import React from 'react'
import {
	ObjectiveIcon,
	ColorlessDefenseIcon,
	ColorlessTransporterIcon,
	ColorlessThrustersIcon,
	ColorlessPowerIcon,
	ColorlessCommunicationsIcon,
	ColorlessTractorBeamIcon,
	ColorlessSensorsIcon,
} from '../../../assets/icons'

export type BasicType =
	| 'OBJECTIVE'
	| 'DEFENSE'
	| 'TRANSPORTER'
	| 'THRUSTERS'
	| 'POWER'
	| 'COMMUNICATION'
	| 'TRACTOR_BEAM'
	| 'MAP'

export type NotificationType = BasicType
export type Notification = {
	id: string,
	type: BasicType,
	value?: number,
	onEnd: () => void,
}

export const NOTIFICATION_TEXT = {
	OBJECTIVE: ' New Objective',
	DEFENSE: 'Defense Activated',
	TRANSPORTER: 'Transporter Activated',
	THRUSTERS: 'Thrusters Activated',
	POWER: 'Power Activated',
	COMMUNICATION: 'Communications Activated',
	TRACTOR_BEAM: 'Tractor Beam Activated',
	MAP: 'New Map Available',
}

export const NOTIFICATION_IMAGE: { [imageType: string]: React$Node } = {
	OBJECTIVE: <img src={ObjectiveIcon} alt={'OBJECTIVE'} />,
	DEFENSE: <img src={ColorlessDefenseIcon} alt={'DEFENSE'} />,
	TRANSPORTER: <img src={ColorlessTransporterIcon} alt={'TRANSPORTER'} />,
	THRUSTERS: <img src={ColorlessThrustersIcon} alt={'THRUSTERS'} />,
	POWER: <img src={ColorlessPowerIcon} alt={'POWER'} />,
	COMMUNICATION: (
		<img src={ColorlessCommunicationsIcon} alt={'COMMUNICATIONS'} />
	),
	TRACTOR_BEAM: <img src={ColorlessTractorBeamIcon} alt={'TRACTOR_BEAM'} />,
	MAP: <img src={ColorlessSensorsIcon} alt={'SENSORS'} />,
}

export const BASIC_NOTIFICATION_LENGTH = 5000
